import { Component, computed, inject, OnDestroy, OnInit, signal, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { ApiService } from 'src/app/core/services/api.service';
import { DataService } from 'src/app/core/services/data.service';
import { Button } from 'src/app/shared/models/button';
import { Point } from 'src/app/shared/models/point';
import * as async from 'async';
import { Service } from 'src/app/shared/models/service';
import { Global_Class } from 'src/app/shared/models/global';
import { DialogService } from 'primeng/dynamicdialog';
import { iAdminService } from 'src/app/core/services/iAdmin.service';
import { ITableColumn, ITableConfig } from '@devinforius/super-compos-17';
import { Subject, Observable, BehaviorSubject, of } from 'rxjs';
import { StatusChangeComponent } from 'src/app/shared/components/modals/status-change/status-change.component';
import { ToastrService } from 'ngx-toastr';
import { IContactService } from 'src/app/core/services/i-contact.service';
import { UserInfo } from 'src/app/shared/models/user-info';
import { catchError, debounceTime, finalize, tap } from 'rxjs/operators';
import { UserRightsService } from 'src/app/core/services/user-rights.service';
import { File } from 'src/app/shared/models/files';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Dialog } from 'primeng/dialog';
import * as moment from 'moment';
import { TenantInfo } from 'src/app/shared/models/tenant-info';
import { Title } from '@angular/platform-browser';
import { IDelibeGlobalService } from 'src/app/core/services/idelibe/global.service';
import { IDelibeMeService } from 'src/app/core/services/idelibe/me.service';
import { IAppConfiguration } from 'src/app/shared/models/response/IAppConfiguration';
import { IGlobalElements } from 'src/app/shared/models/common/IGlobalElements';
import { Contact } from 'src/app/shared/models/iContact/contact';
import { Status_Objets } from 'src/app/shared/models/status_objet';
import { MeRightPoint } from 'src/app/shared/models/point/me-right-point.model';
import { ColumnActiveFilter, ColumnToFilter, DropdownOption } from '@shared/interfaces/dev';
import { ColumnsFilterEvent } from '@shared/types/dev';
import { filterItemsByActiveFilters, sortBy, uniqBy } from '@shared/helpers';
import { PointsAdvancedSearchService } from '../points-advanced-search/services/points-advanced-search.service';
import { ObjectUtils } from '@shared/utils';
import { environment } from 'src/environments/environment';
import { FormOptions } from 'src/app/common/models/form-options';
import { IButton, TranslateService } from '@devinforius/i-essentials';
import { Translater } from 'src/app/core/services/translater';
import { BootstrapCommonIcons } from '@shared/enums';
import { EmergencyDto } from '@shared/interfaces/dtos/emergencies';
import { EmergenciesService } from '@shared/services/emergencies.service';
import { BaseTableConfig } from '@shared/models/dev';

@Component({
  selector: 'app-point-tables',
  templateUrl: './tables.component.html',
  styleUrls: ['./tables.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PointTablesComponent implements OnInit, OnDestroy {
  private readonly pointsAdvancedSearchService = inject(PointsAdvancedSearchService);
  private readonly emergenciesService = inject(EmergenciesService);

  private readonly formOptions = inject(FormOptions);
  private readonly translater = inject(Translater);
  public tableConfigurations: ITableConfig;
  public title: string;
  public loaded: boolean = false;
  public buttons: Button[] = [];

  public items: Point[] = [];
  public itemsCopy = [...this.items];
  public readonly pointsIdSearch = signal<string>('');
  public readonly search$ = new BehaviorSubject<string>('');

  public columns: ITableColumn[] = [];
  public columnsFilters: ColumnToFilter<Point>[] = [];
  public menu: MenuItem[] = [
    {
      label: this.translate.translate('btn.openPoint'),
      icon: 'bi bi-arrow-up-right-square',
      command: (data) => {
        this.showDetails(data);
      },
    },
  ];
  public services: Service[] = [];
  public listOfContacts: Contact[] = [];
  public listOfContactsAdmin: Contact[] = [];
  public globalElements: Global_Class;
  public listOfServices: Service[] = [];
  public dataToSendToQuery: any = {};
  public isTitle: boolean = false;
  public isSearch: boolean = false;
  public fullData;
  public pageSize: number = 50;
  public pageSizeTemp: number = 100;
  public loadingTable = signal<boolean>(false);
  destroy$: Subject<boolean> = new Subject<boolean>();
  public points$: Observable<Point>;
  @ViewChild('formDialogDuplicatePoint') formDialogDuplicatePoint: Dialog;

  public forselection = [];
  public user: UserInfo = null;
  public statutsPoints: Status_Objets[];
  public totalRecords: number;
  public rows: number;
  public first: number = 0;
  public globalConfig = JSON.parse(sessionStorage.getItem('globalConfig'));
  public allSortFieldsToBeSortedByFrontend = [
    'service',
    'linkedSeanceLabel',
    'classementLabel',
    'dossierClassementLabel',
    'matiere',
    'typeDecisionLabel',
    'typePoint',
    'typeSeanceLabel',
    'urgenceNiveauLabel',
    'agentTraitantLabel',
    'echevinatLabel',
  ];
  public allSortFieldToBeModifiedForSortFrontend = [
    { label: 'typeSeanceId', value: 'seanceTypeName' },
    { label: 'serviceId', value: 'service' },
    { label: 'linkedSeance', value: 'linkedSeanceLabel' },
    { label: 'classementId', value: 'classementLabel' },
    { label: 'dossierClassementId', value: 'dossierClassementLabel' },
    { label: 'matiereId', value: 'matiere' },
    { label: 'statutId', value: 'statut' },
    { label: 'agentTraitantId', value: 'agentTraitantLabel' },
    { label: 'typeDecisionId', value: 'typeDecisionLabel' },
    { label: 'typeId', value: 'typePoint' },
    { label: 'typeSeanceId', value: 'typeSeanceLabel' },
    { label: 'urgenceNiveauId', value: 'urgenceNiveauLabel' },
    { label: 'echevinatId', value: 'echevinatLabel' },
    { label: 'courrierId', value: 'courrierIdLabel' },
  ];
  public isUserAbleToAddPoint: boolean = false;
  public sizeOfPages: { label: string; value: number }[] = [
    { label: 'Maximum 50 points affichés', value: 50 },
    { label: 'Maximum 200 points affichés', value: 200 },
    { label: 'Maximum 500 points affichés', value: 500 },
    { label: 'Maximum 1000 points affichés', value: 1000 },
    { label: 'Maximum 5000 points affichés', value: 5000 },
  ];
  public globalConfiguration: IAppConfiguration;
  public displayCourrierId: boolean = false;
  public files: File[] = [];
  public selectedFilesForDuplication: any[] = [];
  public tableConfigDuplication: BaseTableConfig = Object.assign(new BaseTableConfig(), {
    multiselect: true,
    showForSelectionRow: true,
    height: 'calc( 100vh - 400px)',
  });
  public columnsFiles: ITableColumn[] = [
    {
      field: 'description',
      header: 'description',
      filterable: true,
    },
    {
      field: 'extension',
      header: 'extension',
      filterable: true,
    },
    {
      field: 'fileType',
      header: this.translate.translate('fileType'),
      format: (_, item) => {
        if (item.modeleId && item.extension.toLowerCase() === 'pdf') {
          return this.translate.translate('document');
        } else if (item.annexeNumero) {
          return this.translate.translate('annexN°') + ' ' + item.annexeNumero;
        } else {
          return this.translate.translate('associatedFile');
        }
      },
      filterable: true,
    },
    {
      field: 'dateUpload',
      header: 'dateupload',
      format: (value) => {
        if (value) {
          return moment(value).format('DD/MM/YYYY');
        }
      },
      filterable: true,
    },
  ];

  //#Region duplicate point
  public openDuplicationManagementModal: boolean = false;
  public duplicationManagementIndex: number = 0;
  public chosenPointToDuplicate = null;
  public formDuplicationPoint: UntypedFormGroup = new UntypedFormGroup({
    infos: new UntypedFormControl(true),
    files: new UntypedFormControl(null),
    listOfFiles: new UntypedFormControl(null),
    recipients: new UntypedFormControl(null),
  });
  public filesForDuplication: Array<File> = [];
  tableState: any;

  public withSearch = false;
  public withFilters = false;
  public titleButton = computed<IButton>(() => ({
    text: this.translater.translates('COMMON.REFRESH'),
    styleClass: 'blue',
    icon: BootstrapCommonIcons.REFRESH,
    iconPosition: 'left',
    click: () => this.ngOnInit(),
    loading: this.loadingTable(),
  }));

  private readonly emergenciesOptions = signal<EmergencyDto[]>([]);

  private currentStatusId: string = '';
  // Prevents columnSort/pageChange from firing during table initialization (PrimeNG lazy table emits on first render).
  private tableEventEnabled = false;

  //#endregion

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private api: ApiService,
    private IDelibeMeService: IDelibeMeService,
    private IDelibeGlobalService: IDelibeGlobalService,
    private dataS: DataService,
    public dialogService: DialogService,
    public apiAdmin: iAdminService,
    public toastr: ToastrService,
    public icontactService: IContactService,
    public userRightsService: UserRightsService,
    private titleService: Title
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle('Points');
    this.tableEventEnabled = false;
    this.activatedRoute.params.subscribe((route: Params) => {
      this.currentStatusId = route.title;
      this.translateForSelection();
      this.getColumns();
      async.waterfall(
        [
          (callback) => {
            this.apiAdmin.getTenant().subscribe(
              (res: TenantInfo) => {
                res.applications?.map((x) => {
                  if (x.name === 'iCourrier') {
                    this.columns.push({
                      field: 'courrierId',
                      header: 'ID du courrier',
                      visible: false,
                      format: (value) => {
                        if (value) {
                          return value;
                        } else {
                          return '';
                        }
                      },
                      export: (value) => {
                        return value;
                      },
                      filterable: true,
                    });
                  }
                });
                callback();
              },
              () => {
                this.toastr.error('Une erreur est survenue dans la récupération du tenant!');
                callback();
              }
            );
          },
          (callback) => {
            this.setFirstInLocalStorage(0);
            callback();
          },
          (callback) => {
            this.loadTableState();
            callback();
          },
          (callback) => {
            this.fetchEmergencies();
            this.apiAdmin.getUserInfo().subscribe((userInfo) => {
              this.user = new UserInfo(userInfo);
              callback();
            });
          },
          (callback) => {
            this.dataS.getGlobalElements.subscribe((res: IGlobalElements) => {
              this.globalElements = new Global_Class(res);
              if (this.globalElements.isLoaded()) {
                callback(null);
              }
            });
          },
          (callback) => {
            this.icontactService.getLowContacts().subscribe((res: Contact[]) => {
              this.listOfContacts = res;
              callback();
            });
          },
          (callback) => {
            this.icontactService.getLowContactsAdmin().subscribe((res: Contact[]) => {
              this.listOfContactsAdmin = res;
              callback();
            });
          },
          (callback) => {
            this.menu[0].label = this.translate.translate('btn.openPoint');
            callback();
          },
          (callback) => {
            this.tableState.sortOrder = this.tableState.sortOrder
              ? this.tableState.sortOrder === 1
                ? 'ASC'
                : 'DESC'
              : '';
            if (this.pointsAdvancedSearchService.hasActiveSearch()) {
              this.handleAdvancedSearchIfExists();
            } else {
              callback(null);
            }
          },
          (callback) => {
            this.IDelibeGlobalService.getGlobalAllPointsStatuts().subscribe((res: Status_Objets[]) => {
              this.statutsPoints = res.filter((status) => status.utilisable);
              callback();
            });
          },
          (callback) => {
            if (route.title) {
              this.isTitle = true;
              this.isSearch = false;
              this.items = [];
              this.fullData = null;
              switch (route.title) {
                case 'all': {
                  this.title = this.translate.translate('title.allPoints');
                  this.dataToSendToQuery = {
                    PageSize: this.pageSize,
                    PageNumber: 1,
                  };
                  this.getPoints(
                    this.dataToSendToQuery,
                    1,
                    this.tableState.sortField,
                    this.tableState.sortOrder
                  ).subscribe(() => {
                    callback();
                  });
                  break;
                }
                case 'aCorriger': {
                  this.dataToSendToQuery = {
                    PageSize: this.pageSize,
                    PageNumber: 1,
                    ACorriger: true,
                  };
                  this.title = this.translate.translate('title.aCorriger');
                  this.getPoints(
                    this.dataToSendToQuery,
                    1,
                    this.tableState.sortField,
                    this.tableState.sortOrder
                  ).subscribe(() => {
                    callback();
                  });
                  break;
                }
                case 'pourInfo': {
                  this.dataToSendToQuery = {
                    PageSize: this.pageSize,
                    PageNumber: 1,
                    Tag: 'pourInfo',
                  };
                  this.title = this.translate.translate('title.pourInfo');
                  this.getPoints(
                    this.dataToSendToQuery,
                    1,
                    this.tableState.sortField,
                    this.tableState.sortOrder
                  ).subscribe(() => {
                    callback();
                  });
                  break;
                }
                case 'pourAction': {
                  this.dataToSendToQuery = {
                    PageSize: this.pageSize,
                    PageNumber: 1,
                    Tag: 'pourAction',
                  };
                  this.title = this.translate.translate('title.pourAction');
                  this.getPoints(
                    this.dataToSendToQuery,
                    1,
                    this.tableState.sortField,
                    this.tableState.sortOrder
                  ).subscribe(() => {
                    callback();
                  });
                  break;
                }
                case 'mesPointsEnRedaction': {
                  const statut = this.statutsPoints.find((x) => (x.statutAutiliserLorsCreation = true));
                  this.dataToSendToQuery = {
                    PageSize: this.pageSize,
                    PageNumber: 1,
                    CreeParContactId: this.user.contactId,
                    statutIds: statut?.id,
                  };
                  this.title = this.translate.translate('title.mesPointsEnRedaction');
                  this.getPoints(
                    this.dataToSendToQuery,
                    1,
                    this.tableState.sortField,
                    this.tableState.sortOrder
                  ).subscribe(() => {
                    callback();
                  });
                  break;
                }

                default: {
                  //Si on arrive ici c'est qu'on a l'id du statut
                  const index = this.globalElements.statuts_points_LV.map((x) => x.value).indexOf(+route.title);

                  if (index > -1) {
                    // this.title = this.translate.translate(route.title);
                    this.title = this.globalElements.statuts_points[index].description;
                    this.dataToSendToQuery = {
                      PageSize: this.pageSize,
                      PageNumber: 1,
                      statutIds: route.title,
                    };
                    this.getPoints(
                      this.dataToSendToQuery,
                      1,
                      this.tableState.sortField,
                      this.tableState.sortOrder
                    ).subscribe(() => {
                      callback();
                    });
                    break;
                  } else {
                    callback();
                    break;
                  }
                }
              }
            } else if (route.search) {
              this.activatedRoute.queryParams.subscribe((query: Params) => {
                this.isTitle = false;
                this.isSearch = true;
                let rechercheGlobale = '';
                rechercheGlobale = decodeURIComponent(route.search);

                this.title = this.translate.translate('title.searchPoint');
                this.dataToSendToQuery = {
                  PageSize: this.pageSize,
                  PageNumber: 1,
                  RechercheGlobale: rechercheGlobale,
                };
                if (query.CheckContenuRTF) {
                  this.dataToSendToQuery.checkContenuRTF = query.CheckContenuRTF;
                  this.getPoints(
                    this.dataToSendToQuery,
                    1,
                    this.tableState.sortField,
                    this.tableState.sortOrder
                  ).subscribe(() => {
                    callback();
                  });
                }
              });
            }
          },
        ],
        () => {
          this.getITableConfigurations();
          this.loaded = true;
          // Defer enabling table events until after the first render cycle so that
          // PrimeNG's lazy table init events (sort restore, page reset) are ignored.
          setTimeout(() => {
            this.tableEventEnabled = true;
          });

          window.onbeforeunload = () => this.ngOnDestroy();
        }
      );
    });

    this.search$.pipe(debounceTime(700)).subscribe((search) => this.searchByPointId(search));
  }

  private handleAdvancedSearchIfExists(): void {
    this.title = 'Recherche avancée sur les points';
    const query = this.pointsAdvancedSearchService.currentSearch();

    ObjectUtils.removeFalsyEntries(query);
    this.getPoints(query, 1, this.tableState.sortField, this.tableState.sortOrder).subscribe({
      next: () => {
        this.getColumns();
        this.getITableConfigurations();
        window.onbeforeunload = () => this.ngOnDestroy();
        this.loaded = true;
      },
    });
  }

  loadTableState() {
    return new Observable((observer) => {
      const tableState = localStorage.getItem('i-table-state-idTableauDeBordPoints');
      if (tableState) {
        this.tableState = JSON.parse(tableState);
      } else {
        this.tableState = { sortField: 'id', sortOrder: 'ASC' };
      }
      observer.next(null);
      observer.complete();
    });
  }

  getITableConfigurations() {
    this.tableConfigurations = new ITableConfig({
      pageSize: this.rows,
      pageFirst: this.first,
      lazy: true,
      totalRecords: this.totalRecords,
      selectionActions: { export: true, remove: false },
      isRowClickable: true,
      resizableColumns: true,
      reorderableColumns: true,
      rowPerPageOptions: [50, 200, 500, 1000, 5000],
      height: '90vh',
      // scrollable enables scrollHeight (vertical) and horizontal overflow.
      // min-width: 100% keeps the table full-width with few columns, but allows it
      // to grow beyond 100% for many columns (enabling horizontal scroll).
      scrollable: true,
      baseSortColumn: { field: 'id', currentSort: -1 },
      tableStyle: { 'min-width': '100%' },
      showFastSearch: false,
    });
  }
  private setColumnsFilters(): void {
    this.columnsFilters = [
      {
        field: 'id',
        fieldLabel: 'ID du point',
        type: 'number',
      },
      {
        field: 'alreadyReadPt',
        fieldLabel: 'Déjà lu',
        type: 'boolean',
      },
      {
        field: 'title',
        fieldLabel: 'Titre',
        type: 'string',
      },
      {
        field: 'cloture',
        fieldLabel: 'Clôturé',
        type: 'boolean',
      },
      {
        field: 'confidentiel',
        fieldLabel: 'Confidentiel',
        type: 'boolean',
      },
      {
        field: 'serviceId',
        fieldLabel: 'Service',
        type: 'enum',
        multiSelection: true,
        options: this.getAvailableServicesOptions(),
      },
      {
        field: 'seanceId',
        fieldLabel: 'Séance',
        type: 'enum',
        options: this.getAvailableMeetingsOptions(),
      },
      {
        field: 'classementId',
        fieldLabel: 'Code de classement',
        type: 'enum',
        options: this.getAvailableClassificationCodesOptions(),
      },
      {
        field: 'dossierClassementId',
        fieldLabel: 'Farde de classement',
        type: 'enum',
        options: this.getAvailableClassificationFoldersOptions(),
      },
      {
        field: 'seanceLink.date',
        fieldLabel: 'Date de la séance',
        type: 'date',
      },
      {
        field: 'matiereId',
        fieldLabel: 'Matière',
        type: 'enum',
        options: this.getAvailableMattersOptions(),
      },
      {
        field: 'statutId',
        fieldLabel: 'Statut',
        type: 'enum',
        options: this.getAvailableStatusesOptions(),
      },
      {
        field: 'typeDecisionId',
        fieldLabel: 'Type de décision',
        type: 'enum',
        options: this.getAvailableDecisionTypesOptions(),
      },
      {
        field: 'typeId',
        fieldLabel: 'Type de point',
        type: 'enum',
        options: this.getAvailablePointTypesOptions(),
      },
      {
        field: 'typeSeanceId',
        fieldLabel: 'Type de séance',
        type: 'enum',
        options: this.getAvailableMeetingTypesOptions(),
      },
      {
        field: 'verrouille',
        fieldLabel: 'Vérouillé',
        type: 'boolean',
      },
      {
        field: 'checkRGPD',
        fieldLabel: 'RGPD',
        type: 'boolean',
      },
      {
        field: 'echevinatId',
        fieldLabel: 'Echevinat',
        type: 'enum',
        options: this.getAvailableAldermanshipsTypesOptions(),
      },
      {
        field: 'origine',
        fieldLabel: 'Origine',
        type: 'string',
      },
      {
        field: 'creeParContactLabel',
        fieldLabel: 'Créateur',
        type: 'string',
      },
      {
        field: 'agentTraitantIdLabel' as keyof Point,
        fieldLabel: 'Agent traitant',
        type: 'string',
        hide: this.globalConfiguration?.delibConfig?.cacherAgentTraitant,
      },
      {
        field: 'urgenceId' as keyof Point,
        fieldLabel: 'Urgence',
        type: 'enum',
        options: this.getAvailableEmergenciesOptions(),
        hide: this.globalConfiguration?.delibConfig?.contenuMasquerUrgence,
      },
    ];
  }

  private getAvailableServicesOptions(): DropdownOption[] {
    if (this.globalElements.services_LV.length === 0) {
      return [];
    }
    const allOptions = this.items
      .filter((item) => item.serviceId)
      .map((item) => {
        const service = this.globalElements.services_LV.find((x) => x.value === item.serviceId);

        if (!service) return;

        return {
          label: service.label,
          value: item.serviceId,
        };
      })
      .filter((option) => !!option);

    if (allOptions.length === 0) {
      return [];
    }

    return sortBy(uniqBy(allOptions, 'value'), 'label');
  }

  private getAvailableMeetingsOptions(): DropdownOption[] {
    const allOptions = this.items
      .filter((item) => item.seanceId)
      .map((item) => ({ label: item.seanceLink.description, value: item.seanceId }))
      .filter((option) => !!option);

    if (allOptions.length === 0) {
      return [];
    }

    return sortBy(
      uniqBy(
        allOptions.filter((option) => !!option),
        'value'
      ),
      'label'
    );
  }

  private getAvailableClassificationCodesOptions(): DropdownOption[] {
    if (this.globalElements.classement_code_LV.length === 0) {
      return [];
    }
    const allOptions = this.items
      .filter((item) => item.classementId)
      .map((item) => {
        const classificationCode = this.globalElements.classement_code_LV.find((x) => x.value === item.classementId);

        if (!classificationCode) return;

        return {
          label: classificationCode.label,
          value: item.classementId,
        };
      })
      .filter((option) => !!option);

    if (allOptions.length === 0) {
      return [];
    }
    return sortBy(
      uniqBy(
        allOptions.filter((option) => !!option),
        'value'
      ),
      'label'
    );
  }

  private getAvailableClassificationFoldersOptions(): DropdownOption[] {
    if (this.globalElements.classeurs_LV.length === 0) {
      return [];
    }
    const allOptions = this.items
      .filter((item) => item.dossierClassementId)
      .map((item) => {
        const classificationFolder = this.globalElements.classeurs_LV.find((x) => x.value === item.dossierClassementId);

        if (!classificationFolder) return;

        return {
          label: classificationFolder.label,
          value: item.dossierClassementId,
        };
      })
      .filter((option) => !!option);

    if (allOptions.length === 0) {
      return [];
    }
    return sortBy(
      uniqBy(
        allOptions.filter((option) => !!option),
        'value'
      ),
      'label'
    );
  }

  private getAvailableMattersOptions(): DropdownOption[] {
    if (this.globalElements.matieres_LV.length === 0) {
      return [];
    }
    const allOptions = this.items
      .filter((item) => item.matiereId)
      .map((item) => {
        const matter = this.globalElements.matieres_LV.find((x) => x.value === item.matiereId);

        if (!matter) return;

        return {
          label: matter.label,
          value: item.matiereId,
        };
      })
      .filter((option) => !!option);

    if (allOptions.length === 0) {
      return [];
    }

    return sortBy(uniqBy(allOptions, 'value'), 'label');
  }

  private getAvailableStatusesOptions(): DropdownOption[] {
    if (this.globalElements.statuts_points_LV.length === 0) {
      return [];
    }
    const allOptions = this.items
      .filter((item) => item.statutId)
      .map((item) => {
        const statut = this.globalElements.statuts_points_LV.find((x) => x.value === item.statutId);

        if (!statut) return;

        return {
          label: statut.label,
          value: item.statutId,
        };
      })
      .filter((option) => !!option);

    if (allOptions.length === 0) {
      return [];
    }

    return sortBy(uniqBy(allOptions, 'value'), 'label');
  }

  private getAvailableDecisionTypesOptions(): DropdownOption[] {
    if (this.globalElements.decision_type_LV.length === 0) {
      return [];
    }

    const allOptions = this.items
      .filter((item) => item.typeDecisionId)
      .map((item) => {
        const decisionType = this.globalElements.decision_type_LV.find((x) => x.value === item.typeDecisionId);

        if (!decisionType) return;

        return {
          label: decisionType.label,
          value: item.typeDecisionId,
        };
      })
      .filter((option) => !!option);

    if (allOptions.length === 0) {
      return [];
    }

    return sortBy(uniqBy(allOptions, 'value'), 'label');
  }

  private getAvailablePointTypesOptions(): DropdownOption[] {
    if (this.globalElements.types_points_LV.length === 0) {
      return [];
    }

    const allOptions = this.items
      .filter((item) => item.typeId)
      .map((item) => {
        const pointType = this.globalElements.types_points_LV.find((x) => x.value === item.typeId);

        if (!pointType) return;

        return {
          label: pointType.label,
          value: item.typeId,
        };
      })
      .filter((option) => !!option);

    if (allOptions.length === 0) {
      return [];
    }

    return sortBy(uniqBy(allOptions, 'value'), 'label');
  }

  private getAvailableMeetingTypesOptions(): DropdownOption[] {
    if (this.globalElements.types_seances_LV.length === 0) {
      return [];
    }

    const allOptions = this.items
      .filter((item) => item.typeSeanceId)
      .map((item) => {
        const meetingType = this.globalElements.types_seances_LV.find((x) => x.value === item.typeSeanceId);
        if (!meetingType) return;

        return {
          label: meetingType.label,
          value: item.typeSeanceId,
        };
      })
      .filter((option) => !!option);

    if (allOptions.length === 0) {
      return [];
    }

    return sortBy(uniqBy(allOptions, 'value'), 'label');
  }

  private fetchEmergencies(): void {
    this.emergenciesService
      .fetchEmergencies()
      .pipe(catchError(() => of([] as EmergencyDto[])))
      .subscribe({
        next: (res) => {
          this.emergenciesOptions.set(res);
        },
      });
  }

  private getAvailableAldermanshipsTypesOptions(): DropdownOption[] {
    if (this.emergenciesOptions().length === 0) {
      return [];
    }

    const allOptions = this.items
      .filter((item) => item.echevinatId)
      .map((item) => {
        const aldermanshipType = this.formOptions.aldermanships().find((x) => x.id === item.echevinatId);
        if (!aldermanshipType) return;
        return {
          label: aldermanshipType.description,
          value: item.echevinatId,
        };
      })
      .filter((option) => !!option);

    if (allOptions.length === 0) {
      return [];
    }

    return sortBy(uniqBy(allOptions, 'value'), 'label');
  }

  private getAvailableEmergenciesOptions(): DropdownOption[] {
    if (this.emergenciesOptions().length === 0) {
      return [];
    }

    const allOptions = this.items
      .filter((item) => (item as Point & { urgenceId: number }).urgenceId)
      .map((item) => {
        const emergency = this.emergenciesOptions().find(
          (x) => x.id === (item as Point & { urgenceId: number }).urgenceId
        );
        if (!emergency) return;
        return {
          label: emergency.description,
          value: (item as Point & { urgenceId: number }).urgenceId,
        };
      })
      .filter((option) => !!option);

    if (allOptions.length === 0) {
      return [];
    }

    return sortBy(uniqBy(allOptions, 'value'), 'label');
  }

  receive_menu(event) {
    const temp = [
      {
        label: this.translate.translate('btn.openPoint'),
        command: () => {
          this.showDetails(event);
        },
      },
    ];
    this.menu = [{}];
    async.waterfall(
      [
        (callback) => {
          this.IDelibeMeService.getRightsPoint(event.id).subscribe((rights: MeRightPoint) => {
            if (rights.edit) {
              temp.push({
                label: this.translate.translate('btn.modify'),
                command: () => {
                  this.updatePoint(event.id);
                },
              });
            }
            callback();
          });
        },
        (callback) => {
          if (this.isUserAbleToAddPoint) {
            temp.push({
              label: this.translate.translate('btn.duplicate'),
              command: () => {
                //! Be careful to always check the files, you don't always come from the files tab
                this.chosenPointToDuplicate = event;
                this.getFiles(event.id);
                this.duplicationManagementIndex = 0; //index used to display a certain part of the modal
                this.openDuplicationManagementModal = true; //opens the html modal to choose the desired settings for duplication
              },
            });
          }
          callback();
        },
      ],
      () => {
        this.menu = temp;
      }
    );
  }

  //* method used when user submits the form on the duplication modal management (whatever part he's in)
  //@params no params needed, all is set by the form
  submitDuplicationManagement() {
    if (this.duplicationManagementIndex === 0) {
      //on va alors vérifier si on veut des fichiers. Si oui, on va faire choisir les fichiers a l'utilisateur
      if (this.formDuplicationPoint.value.files) {
        this.duplicationManagementIndex = 1;
        this.formDialogDuplicatePoint.resetPosition();
      } else {
        //si pas, on va simplement aller dans l'interface de création/duplication
        //* on doit récupérer le point dans ce component a cause du tableau en effet, par ex classementId est le label!!
        this.api.getPointByID(this.chosenPointToDuplicate.id).subscribe((res) => {
          this.dataS.SetDuplicatedPoint(res);
          this.dataS.setDuplicatedPointManagement(this.formDuplicationPoint.value);
          this.router.navigateByUrl(`/private/points/duplicate/${this.chosenPointToDuplicate.id}`);
        });
      }
    } else if (this.duplicationManagementIndex === 1) {
      //on est ds le tableau des fichiers
      //ici on va envoyer les ids des fichiers cochés dans le formulaire à renvoyer
      //* on doit récupérer le point dans ce component a cause du tableau en effet, par ex classementId est le label!!
      this.api.getPointByID(this.chosenPointToDuplicate.id).subscribe((res) => {
        this.dataS.SetDuplicatedPoint(res);
        this.formDuplicationPoint.patchValue({
          listOfFiles: this.selectedFilesForDuplication.map((file) => file.id),
        });
        this.dataS.setDuplicatedPointManagement(this.formDuplicationPoint.value);
        this.router.navigateByUrl(`/private/points/duplicate/${this.chosenPointToDuplicate.id}`);
      });
    }
  }

  public onDuplicationFilesSelectionChange(files: any[]): void {
    this.selectedFilesForDuplication = files;
  }

  //*get the point's files
  getFiles(pointId) {
    this.api.getPointFiles(pointId).subscribe(
      (data) => {
        data.map((x) => new File(x));
        this.filesForDuplication = data.filter((x) => !x.modeleId);
        this.selectedFilesForDuplication = [...this.filesForDuplication];
      },
      () => {
        this.filesForDuplication = [];
      }
    );
  }

  private showBoolean(value) {
    if (value) {
      return `<b style="color: #07E299;"><i class="bi bi-check-circle-fill"></i></b>`;
    } else if (value === -1) {
      return `<b style="color: #FFAF2F;"><i class="bi bi-hourglass-split"></i></b>`;
    } else {
      return `<b style="color: #FF5671;"></b>`;
    }
  }

  ngOnDestroy(): void {
    const temp = JSON.parse(localStorage.getItem('state-of-table-idTableauDeBordPoint'));
    if (temp) {
      temp.first = 0;
      localStorage.setItem('state-of-table-idTableauDeBordPoint', JSON.stringify(temp));
    }
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  showDetails(event) {
    window.open(`${environment.baseUrl}/private/points/detail/${event.id}`, '_blank');
  }

  updatePoint(event) {
    this.router.navigateByUrl('/private/points/update/' + event);
  }

  setFirstInLocalStorage(firstValue: number) {
    const tableStateJSON = localStorage.getItem('i-table-state-idTableauDeBordPoints');
    const tableState = tableStateJSON ? JSON.parse(tableStateJSON) : {};
    this.tableState = tableState;
    tableState.first = firstValue;
    tableState.rows = tableState.rows ? tableState.rows : 50;
    //! encore un soucis parce que si je change la taille de la page, il me remet
    //! une taille par défaut de la i-table [50,100,200, ...]
    localStorage.setItem('i-table-state-idTableauDeBordPoints', JSON.stringify(tableState));
  }

  getPoints(data?: any, pageNumber?: number, sortField?: string, sortOrder?: string) {
    switch (this.currentStatusId) {
      case 'all': {
        data = {
          PageSize: this.pageSize,
          PageNumber: 1,
        };

        break;
      }
      case 'aCorriger': {
        data = {
          PageSize: this.pageSize,
          PageNumber: 1,
          ACorriger: true,
        };

        break;
      }
      case 'pourInfo': {
        data = {
          PageSize: this.pageSize,
          PageNumber: 1,
          Tag: 'pourInfo',
        };

        break;
      }
      case 'pourAction': {
        data = {
          PageSize: this.pageSize,
          PageNumber: 1,
          Tag: 'pourAction',
        };

        break;
      }
      case 'mesPointsEnRedaction': {
        const statut = this.statutsPoints.find((x) => (x.statutAutiliserLorsCreation = true));
        data = {
          PageSize: this.pageSize,
          PageNumber: 1,
          CreeParContactId: this.user.contactId,
          statutIds: statut?.id,
        };

        break;
      }

      default: {
        const index = this.globalElements.statuts_points_LV.map((x) => x.value).indexOf(+this.currentStatusId!);

        if (index > -1) {
          data = {
            PageSize: this.pageSize,
            PageNumber: 1,
            statutIds: +this.currentStatusId,
          };
        }
        break;
      }
    }

    // Apply the requested page number after the switch, which overwrites the hardcoded PageNumber: 1 in each case.
    data.PageNumber = pageNumber ?? 1;

    sortField && sortField !== '' ? (data.SortFields = sortField) : null;
    sortOrder && sortOrder !== '' ? (data.SortOrder = sortOrder) : null;
    this.loadingTable.set(true);
    this.items = [];
    this.tableConfigurations = null;
    return this.api.getSearchPoint(this.removeEmpty(data)).pipe(
      tap((response: any) => {
        const items = Array.isArray(response.items) ? response.items : typeof response === 'object' ? [response] : [];
        this.items = items.map(
          (x) => new Point(x, this.globalElements, null, this.listOfContactsAdmin, this.listOfContacts)
        );
        this.totalRecords = response.totalCount;
        this.rows = response.pageSize;
        this.first = response.pageNumber === 1 ? 0 : this.rows * (response.pageNumber - 1);
        this.getITableConfigurations();
        this.setColumnsFilters();
      }),
      finalize(() => this.loadingTable.set(false))
    );
  }

  removeEmpty(obj) {
    return Object.keys(obj)
      .filter(function (k) {
        return obj[k] != null;
      })
      .reduce(function (acc, k) {
        if (!Array.isArray(obj[k]) && !(obj[k] instanceof Date)) {
          acc[k] = typeof obj[k] === 'object' ? this.removeEmpty(obj[k]) : obj[k];
        } else {
          acc[k] = obj[k];
        }
        return acc;
      }, {});
  }

  translateForSelection() {
    this.forselection = [
      {
        label: this.translate.translate('statusModification'),
        tooltip: this.translate.translate('statusModification'),
        command: (value) => {
          this.openPointStatusChangeModal(value);
        },
      },
    ];
  }

  public openPointStatusChangeModal(selection) {
    const ref = this.dialogService.open(StatusChangeComponent, {
      data: {
        points: true,
        listOfPoints: selection,
        header: this.translate.translate('statusModifications'),
      },
      width: '70vw',
      styleClass: 'super-compos-modal-content ',
      showHeader: false,
      closable: false,
      dismissableMask: false,
      baseZIndex: 1000,
    });
    ref.onClose.subscribe((status: number) => {
      if (status) {
        this.toastr.info('Changement de statut en cours, veuillez patienter');
        async.eachSeries(
          selection,
          (item: Point, nextFile) => {
            this.api.putChangeStatusPoint(item.id, status).subscribe(() => {
              nextFile();
            });
          },
          () => {
            this.ngOnInit();
            this.toastr.success('Les statuts des points ont bien été modifiés.');
          }
        );
      }
    });
  }

  getColumns() {
    this.IDelibeGlobalService.getConfiguration().subscribe((res: IAppConfiguration) => {
      this.globalConfiguration = res;
      this.columns = [
        {
          field: 'id',
          header: 'ID',
          filterable: true,
          sortable: true,
          format: (_, item) => {
            return item.id;
          },
          export: (_, item) => {
            return item.id;
          },
        },
        {
          field: 'alreadyReadPt',
          header: 'Lu',
          filterable: true,
          width: '20px',
          sortable: true,

          format: (_, item) => {
            return `<span style="font-size: 24px"><i class="bi bi-${item.alreadyReadPt ? 'envelope-open' : 'envelope-fill'}"></span>`;
          },
          export: (_, item) => {
            return item.alreadyReadPt ? 'Oui' : 'Non';
          },
        },
        {
          field: 'objetSynthese',
          header: 'Titre',
          sortable: true,
          maxWidth: '200px',
          type: 'string',
          format: (_, item) => {
            return item.objetSynthese;
          },
          export: (_, item) => {
            return item.objetSynthese;
          },
          filterable: true,
        },
        {
          field: 'cloture',
          header: 'Cloturé',
          sortable: true,
          format: (_, item) => this.showBoolean(item.cloture),
          export: (_, item) => {
            if (item.cloture) {
              return `✔️`;
            } else if (item.cloture === -1) {
              return `⏳`;
            } else {
              return `❌`;
            }
          },
          filterable: true,
        },
        {
          field: 'confidentiel',
          header: 'Confidentiel',
          sortable: true,
          visible: false,
          format: (_, item) => {
            if (item?.type !== 'event') {
              if (item.confidentiel === true) {
                return this.showBoolean(item.confidentiel);
              } else if (item.confidentiel === false) {
                return '';
              } else if (item.confidentiel === null) {
                return '';
              }
            }
          },
          export: (_, item) => {
            if (item.confidentiel === true) {
              return `✔️`;
            } else if (item.confidentiel === false) {
              return `❌`;
            } else if (item.confidentiel === null) {
              return '';
            }
          },
          filterable: true,
        },
        {
          field: 'serviceId',
          header: 'Service',
          sortable: true,
          type: 'string',
          format: (value) => {
            if (value) {
              const service = this.globalElements.services_LV.find((x) => x.value === value);
              if (service) {
                return service.label;
              }
            } else {
              return '';
            }
          },
          export: (value) => {
            return value;
          },
          filterable: true,
        },
        {
          field: 'seanceLink.description',
          header: 'Séance',
          sortable: true,
          format: (_, item) => {
            return item.seanceLink?.description;
          },
          filterable: true,
        },
        {
          field: 'classementId',
          header: 'Classement',
          sortable: true,
          visible: false,
          format: (_, item) => {
            if (item?.type !== 'event') {
              if (item.classementId && this.globalElements?.classement_code_LV) {
                const element = this.globalElements.classement_code_LV.find((x) => x.value === item.classementId);
                if (element) {
                  return element?.label;
                } else {
                  return '/';
                }
              } else if (!item.classementId) {
                return '/';
              }
            } else {
              return '/';
            }
          },
          export: (value) => {
            return value;
          },
          filterable: true,
        },
        {
          field: 'dossierClassementId',
          header: 'Dossier',
          sortable: true,
          visible: false,
          format: (_, item) => {
            if (item?.type !== 'event') {
              if (item.dossierClassementId && this.globalElements?.classeurs_LV) {
                const element = this.globalElements.classeurs_LV.find((x) => x.value === item.dossierClassementId);
                if (element) {
                  return element?.label;
                } else {
                  return '/';
                }
              } else if (!item.dossierClassementId) {
                return '/';
              }
            }
          },
          export: (value) => {
            return value;
          },
          filterable: true,
        },
        {
          field: 'seanceLink.date',
          header: 'Date de séance',
          sortable: true,
          visible: false,
          format: (_, item) => {
            if (item?.seanceLink?.date) {
              return this.formatIsoDateToCustom(item.seanceLink.date);
            }
          },
          export: (_, item) => {
            return this.formatIsoDateToCustom(item.seanceLink.date);
          },
          filterable: true,
        },
        {
          field: 'matiereId',
          header: 'Matière',
          sortable: true,
          visible: false,
          format: (_, item) => {
            if (item?.type !== 'event') {
              if (item.matiereId && this.globalElements?.matieres_LV) {
                const element = this.globalElements.matieres_LV.find((x) => x.value === item.matiereId);
                if (element) {
                  return element?.label;
                } else {
                  return '/';
                }
              } else if (!item.matiereId) {
                return '';
              }
            }
          },
          export: (value) => {
            return value;
          },
          filterable: true,
        },
        {
          field: 'statusLabel',
          header: 'Statut',
          sortable: true,
          type: 'string',
          visible: false,
          format: (value) => {
            return value;
          },
          export: (value) => {
            return value;
          },
          filterable: true,
        },
        {
          field: 'typeDecisionId',
          header: 'Type de décision',
          sortable: true,
          format: (_, item) => {
            if (item?.type !== 'event') {
              if (item.typeDecisionId && this.globalElements?.decision_type_LV) {
                const element = this.globalElements?.decision_type_LV.find((x) => x.value === item.typeDecisionId);
                if (element) {
                  return element?.label;
                } else {
                  return '/';
                }
              } else if (!item.typeDecisionId) {
                return '';
              }
            }
          },
          export: (value) => {
            return value;
          },
          filterable: true,
        },
        {
          field: 'typePoint',
          header: 'Type',
          sortable: true,
          visible: false,
          format: (_, item) => {
            if (item?.type !== 'event') {
              return item?.typePoint;
            }
          },
          export: (value) => {
            return value;
          },
          filterable: true,
        },
        {
          field: 'typeSeanceId',
          header: 'Type séance',
          sortable: true,
          format: (_, item) => {
            if (item?.type !== 'event') {
              if (item.typeSeanceId && this.globalElements?.types_seances_LV) {
                const element = this.globalElements.types_seances_LV.find((x) => x.value === item.typeSeanceId);
                if (element) {
                  return element?.label;
                } else {
                  return '/';
                }
              }
            }
          },
          export: (value) => {
            return value;
          },
          filterable: true,
        },
        {
          field: 'verrouille',
          header: 'Verrouillé',
          sortable: true,
          format: (_, item) => {
            if (item?.type !== 'event') {
              return this.showBoolean(item.verrouille);
            }
          },
          export: (_, item) => {
            if (item.verrouille) {
              return `✔️`;
            } else if (item.verrouille === -1) {
              return `⏳`;
            } else {
              return `❌`;
            }
          },
          filterable: true,
        },
        {
          field: 'checkRGPD',
          header: 'RGPD',
          sortable: true,
          visible: false,
          format: (_, item) => {
            if (item?.type !== 'event') {
              return this.showBoolean(item.checkRgpd);
            }
          },
          export: (_, item) => {
            if (item.checkRgpd) {
              return `✔️`;
            } else if (item.checkRgpd === -1) {
              return `⏳`;
            } else {
              return `❌`;
            }
          },
          filterable: true,
        },

        {
          field: 'echevinatId',
          header: 'Echevinat',
          sortable: true,
          visible: false,
          format: (_, item) => {
            if (item?.type !== 'event') {
              if (item.echevinatId && this.globalElements?.echevinats_LV) {
                const element = this.globalElements.echevinats_LV.find((x) => x.value === item.echevinatId);
                if (element) {
                  return element?.label;
                } else {
                  return '/';
                }
              } else if (!item.echevinatId) {
                return '';
              }
            }
          },
          export: (value) => {
            return value;
          },
          filterable: true,
        },
        {
          field: 'origine',
          header: 'Origine',
          sortable: true,
          visible: false,
          export: (value) => {
            return value;
          },
          filterable: true,
        },
        {
          field: 'creeParContactLabel',
          header: 'Createur',
          sortable: true,
          visible: false,
          export: (_, item) => {
            return item.creeParContactLabel;
          },
          filterable: true,
        },
      ];

      if (!this.globalConfiguration?.delibConfig?.cacherAgentTraitant) {
        this.columns.push({
          field: 'agentTraitantIdLabel',
          header: 'Agent traitant',
          visible: false,
          format: (_, item) => {
            if (item?.type !== 'event') {
              return item?.agentTraitantLabel;
            }
          },
          export: (value) => {
            return value;
          },
          filterable: true,
        });
      }

      if (!this.globalConfiguration?.delibConfig?.contenuMasquerUrgence) {
        this.columns.push({
          field: 'urgenceNiveauIdLabel',
          header: 'Urgence',
          visible: false,
          format: (_, item) => {
            if (item?.type !== 'event') {
              if (item.urgenceNiveauId && this.globalElements?.urgence_level_LV) {
                const element = this.globalElements.urgence_level_LV.find((x) => x.value === item.urgenceNiveauId);
                if (element) {
                  return element?.label;
                } else {
                  return '';
                }
              } else if (!item.urgenceNiveauId) {
                return '';
              }
            }
          },
          export: (value) => {
            return value;
          },
          filterable: true,
        });
      }
    });
  }

  formatIsoDateToCustom(isoDateString: string): string {
    const date = new Date(isoDateString);
    // Ajoute un zéro initial pour les jours et les mois < 10
    const pad = (num: number): string => (num < 10 ? `0${num}` : num.toString());
    const formattedDate = `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} `;
    return formattedDate;
  }

  private resetSearch(): void {
    this.withSearch = false;
    this.itemsCopy = [];
    this.search$.next('');
    this.pointsIdSearch.set('');
  }

  private resetFilters(): void {
    this.withFilters = false;
  }

  pageChange(event) {
    this.resetSearch();
    this.resetFilters();
    this.pageSizeTemp = event.rows;
    const pageNumber = event.first / event.rows + 1;
    let sortField;
    if (event.sortField) {
      const index = this.allSortFieldToBeModifiedForSortFrontend.map((x) => x.label).indexOf(event.sortField);
      if (index > -1) {
        sortField = this.allSortFieldToBeModifiedForSortFrontend[index].value;
      } else {
        sortField = event.sortField;
      }
    }
    const sortOrder = event.sortOrder ? (event.sortOrder === 1 ? 'ASC' : 'DESC') : '';
    this.dataToSendToQuery.PageSize = this.pageSizeTemp;
    this.pageSize = this.pageSizeTemp;
    const query = this.pointsAdvancedSearchService.currentSearch() ?? {};

    console.log(query);

    query.PageSize = this.pageSizeTemp;

    ObjectUtils.removeFalsyEntries(query);

    this.getPoints(query, pageNumber, sortField, sortOrder).subscribe();
  }

  columnSort(event) {
    if (!this.tableEventEnabled) return;
    const sortOrder = event[0].sort ? (event[0].sort === 1 ? 'ASC' : 'DESC') : '';
    this.getPoints(this.dataToSendToQuery, 1, event[0].field, sortOrder).subscribe();
  }

  public onSearchPointId(): void {
    this.withSearch = !!this.pointsIdSearch().trim().length;
    this.search$.next(this.pointsIdSearch().trim());
  }

  public searchByPointId(search: string): void {
    if (!search.length) return;

    this.itemsCopy = this.items.filter((item) => item.id.toString() === search);
  }

  private getFilteredPoints(filters: ColumnActiveFilter<Point>[]): Point[] {
    return filterItemsByActiveFilters(this.items, this.columnsFilters, filters);
  }

  public onFilterPointsCurrentTablePage(event: ColumnsFilterEvent<Point>): void {
    this.withFilters = true;
    this.withSearch = false;
    this.search$.next('');
    this.itemsCopy = this.getFilteredPoints(event.filters);
  }

  public onFilterReset(): void {
    this.withFilters = false;
    this.getPoints().subscribe();
  }
}
